// extracted by mini-css-extract-plugin
module.exports = {"button":"button___1mTI1","isText":"isText___3Q_1U","isDisabled":"isDisabled___34ng_"};